module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/dashboard'
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Overview ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Pages\n      ")]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/data'
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" Data\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/graphs'
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Graphs\n        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/support',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" Support\n        ")])], 1)]), _vm._v(" "), (_vm.$session.user.company) ? _c('div', {
    staticClass: "company-logo"
  }, [(_vm.$session.user.company.logo) ? _c('img', {
    attrs: {
      "src": _vm.$session.user.company.logo
    }
  }) : _c('span', [_vm._v("\n        " + _vm._s(_vm.$session.user.company.name) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da3ceed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 732
// module chunks = 8